module.exports = __webpack_public_path__ + "static/media/Aron_gaussian2.fdd68e65.png";